<ion-header class="ion-no-border">
  <ion-toolbar color="white">

    <ion-buttons slot="start" *ngIf="barber">
      <ion-back-button text="Back to {{barber.firstName}}'s profile" defaultHref="events" (click)="closeAndReject()"></ion-back-button>
    </ion-buttons>

    <ion-title>
      <img src="assets/img/shortcut-logo.png" alt="Shortcut" class="logo"/>
    </ion-title>

  </ion-toolbar>
</ion-header>

<img class="left-oval" src="assets/img/ovals/grey-oval-left.png"/>

<ion-content>

  <div class="booking-module" *ngIf="barber">


    <!-- TIMER -->

    <div class="timer-container" *ngIf="timer && !confirmed">
      <p><span class="time" [ngClass]="timerSecLeft(15) ? 'red' : ''">{{timer.countdownString}}</span> time left to book</p>
    </div>



    <!-- PRO INFO -->

    <div class="pic-wrapper">
      <img class="barber-pic" [src]="barber.pic"/>
    </div>
    <div class="info-header">Book {{barber.firstName}}</div>
    <div class="info-details">
      <span class="info-stars">
        <ion-icon name="star" [ngClass]="barber.numRatings <= 3 ? 'stars-less-opaque' : ''" *ngFor="let _ of toRange(roundedRating(barber.averageRating))"></ion-icon>
        <span class="rating-label" *ngIf="barber.numRatings > 3">({{barber.numRatings}})</span>
      </span>
    </div>
    <hr>
    <ion-icon name="calendar" class="calendar-icon" color="darkgrey"></ion-icon>
    <div class="info-time">
      <b *ngIf="confirmed" style="line-height: 30px">CONFIRMED:<br></b>
      {{eventSelectedService.serviceTitle}} at {{prettyTime(eventSelectedTimeslot.startTime)}}
    </div>





    <!-- FORM FIELDS -->

    <div class="booking-form" *ngIf="!addingNewPayment && !confirming">


      <!-- ADDRESS -->

      <p class="booking-input-header">Event name</p>
      <div class="booking-selector">
        <ion-item lines="none">
          <ion-label>
            {{ eventInfo.name }}
          </ion-label>
        </ion-item>
      </div>


      <span *ngIf="eventInfo.requiresPayment">

        <p class="booking-input-header">Billing information</p>


        <!-- CUSTOMER SELECTOR -->

        <div *ngIf="selectedCustomer" class="booking-selector" [ngClass]="paymentPickerOpen ? '' : 'hover-red'">
          <ion-item class="booking-input" lines="none" (click)="editPayment()" >
            <ion-label>
              {{ selectedPaymentCardText() }}
            </ion-label>
            <ion-icon slot="end" name="chevron-down-outline"></ion-icon>
          </ion-item>

          <div class="selector-customer-options" *ngIf="paymentPickerOpen">
            <ion-item class="dark" (click)="closePaymentPicker()" lines="none">
              <ion-label>
                {{ selectedPaymentCardText() }}
              </ion-label>
              <ion-icon slot="end" name="chevron-down-outline"></ion-icon>
            </ion-item>

            <div class="customer-options">

              <ion-item class="dark" lines="none" (click)="addNewPayment()">
                <ion-label>
                  Add new payment method
                </ion-label>
              </ion-item>

              <div *ngFor="let customer of userService.user.allCustomers" (click)="selectCustomer(customer)">
                <ion-item lines="none" [ngClass]="customerSelected(customer) ? 'dark' : ''">
                  <ion-label>
                    {{ paymentCardText(customer) }}
                  </ion-label>
                  <ion-icon slot="end" name="checkmark" class="checkmark-icon" *ngIf="customerSelected(customer)"></ion-icon>
                </ion-item>
              </div>

            </div>

          </div>

        </div>


        <!-- IF NO CUSTOMER SELECTED, SHOW PAYMENT FORM INLINE -->

        <div *ngIf="!selectedCustomer">
          <ion-item class="booking-input" lines="none">
            <ion-input placeholder="Name on card" [(ngModel)]="cardFields.cardholderName" name="cardholderName" type="text" #cardholderName="ngModel"></ion-input>
          </ion-item>
          <div class="form-row">
            <div id="card-element">
              <!-- a Stripe Element will be inserted here. -->
            </div>
            <div id="card-errors"></div>
          </div>
        </div>

      </span>


      <!-- PROMO CODE -->

      <!-- <p class="booking-input-header">Promo code</p>
      <ion-item class="booking-input" lines="none" *ngIf="!promoCode">
        <ion-input placeholder="Enter promo code" [(ngModel)]="fields.promoCode" name="promoCode" type="text" #promoCode="ngModel"></ion-input>
        <ion-button slot="end" fill="clear" (click)="applyPromoCode()">Apply</ion-button>
      </ion-item>
      <p class="promo-applied" *ngIf="promoCode">Applied: <span class="promo">{{promoCode}}</span> 🎉<span class="remove-button">Remove</span></p> -->



      <!-- CONFIRM BUTTON -->

      <div class="submit-button">
        <ion-button *ngIf="cost" color="marine" (click)="confirmPressed()" class="SC-floating-button SC-floating-button-wide SC-floating-button-less-tall" style="text-transform: none">Confirm booking - {{formatCost(cost.total, eventInfo.currency)}}</ion-button>
        <ion-button *ngIf="!cost" color="marine" (click)="confirmPressed()" class="SC-floating-button SC-floating-button-wide SC-floating-button-less-tall" style="text-transform: none">Confirm booking</ion-button>
      </div>

      <p class="view-receipt-button" *ngIf="eventInfo.requiresPayment" (click)="viewReceipt()">Summary of charges</p>

    </div>





    <!-- ADD NEW PAYMENT -->

    <div class="add-payment-form" *ngIf="addingNewPayment && !confirming">

      <span class="back-to-checkout-button" (click)="returnToCheckout()">
        <ion-icon name="arrow-back"></ion-icon>
        Back to checkout
      </span>

      <div>
        <ion-item class="booking-input" lines="none">
          <ion-input placeholder="Name on card" [(ngModel)]="cardFields.cardholderName" name="cardholderName" type="text" #cardholderName="ngModel"></ion-input>
        </ion-item>
        <div class="form-row">
          <div id="card-element">
            <!-- a Stripe Element will be inserted here. -->
          </div>
          <div id="card-errors"></div>
        </div>
      </div>

      <div class="submit-button">
        <ion-button color="marine" (click)="saveNewPayment()" class="SC-floating-button SC-floating-button-wide SC-floating-button-less-tall">Save payment method</ion-button>
      </div>

    </div>




    <!-- CONFIRMING / CONFIRMED -->

    <div *ngIf="confirming" class="confirming-section">

      <div *ngIf="!confirmed">
        <div class="loading-spinner">
          <ion-spinner></ion-spinner>
        </div>

        <div class="confirming-text">
          Confirming appointment...
        </div>
      </div>

      <div *ngIf="confirmed">

        <hr>

        <div class="submit-button">
          <ion-button color="white" (click)="openCalendarPicker()"
            class="SC-floating-button SC-floating-button-wide SC-floating-button-less-tall">
            Add to calendar
          </ion-button>
        </div>

        <div class="submit-button second">
          <ion-button color="marine" (click)="viewUpcoming()" class="SC-floating-button SC-floating-button-wide SC-floating-button-less-tall">View upcoming appointments</ion-button>
        </div>
      </div>

    </div>

  </div>

  <confirm-footer></confirm-footer>

</ion-content>